import { withPreRenderSettings } from '@/utils/hocs';
import { NewAdView } from '@/views/Ads/NewAd.view';
import { getNewAdDefaultValues } from '@/api/helpers/ad.helpers';
import { NewAdDefaultValues } from '@/api/types/ads.types';
import NoSsr from '@/components/NoSsr/NoSsr';
import { apolloClient } from '@/api/apolloClient';
import { GetRegionsResponse } from '@/api/types/regions.types';
import { GET_REGIONS } from '@/api/queries/regions.queries';

interface Props {
  defaultValues: NewAdDefaultValues | null;
}

function NewAdPage({ defaultValues }: Props) {
  return (
    <NoSsr>
      <NewAdView {...defaultValues} />
    </NoSsr>
  );
}

NewAdPage.getInitialProps = withPreRenderSettings(async (context, client) => {
  const regionsData = await apolloClient<GetRegionsResponse>(
    client,
    { query: GET_REGIONS },
    context
  );

  const defaultValues = await getNewAdDefaultValues(
    client,
    context,
    regionsData?.data
  );

  return { defaultValues };
});

export default NewAdPage;
